import HomePageSections from '../../features/HomePage'

const HomePage = () => {
  return (
    <HomePageSections />
  )
}

export default HomePage